const configTerms = {
    service: {
        listLayout: 'TermsListDefaultLayout',
        // filterLayout: 'TermsFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getTerms',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
    },
    privacy: {
        listLayout: 'TermsListDefaultLayout',
        // filterLayout: 'TermsFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getTerms',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
    },
    leave: {
        listLayout: 'TermsListDefaultLayout',
        // filterLayout: 'TermsFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getTerms',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
    },
    auctionSell: {
        listLayout: 'TermsListDefaultLayout',
        // filterLayout: 'TermsFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getTerms',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
    },
    product: {
        listLayout: 'TermsListDefaultLayout',
        // filterLayout: 'TermsFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getTerms',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
    },
    itembuy: {
        listLayout: 'TermsListDefaultLayout',
        // filterLayout: 'TermsFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getTerms',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
    },
    auctionBuy: {
        listLayout: 'TermsListDefaultLayout',
        // filterLayout: 'TermsFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getTerms',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
    },
    licenseSell: {
        listLayout: 'TermsListDefaultLayout',
        // filterLayout: 'TermsFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getTerms',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
    },
    licenseBuy: {
        listLayout: 'TermsListDefaultLayout',
        // filterLayout: 'TermsFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getTerms',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
    },
    productSell: {
        listLayout: 'TermsListDefaultLayout',
        // filterLayout: 'TermsFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getTerms',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
    },
    contest: {
        listLayout: 'TermsListDefaultLayout',
        // filterLayout: 'TermsFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getTerms',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
    },
    contestItem: {
        listLayout: 'TermsListDefaultLayout',
        // filterLayout: 'TermsFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getTerms',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
    },
    contestWin: {
        listLayout: 'TermsListDefaultLayout',
        // filterLayout: 'TermsFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getTerms',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
    },
    curation: {
        listLayout: 'TermsListDefaultLayout',
        // filterLayout: 'TermsFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getTerms',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
    },
    curator: {
        listLayout: 'TermsListDefaultLayout',
        // filterLayout: 'TermsFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getTerms',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
    },
    curatorForm: {
        listLayout: 'TermsListDefaultLayout',
        // filterLayout: 'TermsFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getTerms',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
    },
    lawsuit: {
        listLayout: 'TermsListDefaultLayout',
        // filterLayout: 'TermsFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getTerms',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
    },
    lawsuitRequest: {
        listLayout: 'TermsListDefaultLayout',
        // filterLayout: 'TermsFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getTerms',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
    },
    mingle: {
        listLayout: 'TermsListDefaultLayout',
        // filterLayout: 'TermsFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getTerms',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
    },
    charge: {
        listLayout: 'TermsListDefaultLayout',
        // filterLayout: 'TermsFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getTerms',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
    },
    withdraw: {
        listLayout: 'TermsListDefaultLayout',
        // filterLayout: 'TermsFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getTerms',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
    },
    detection: {
        listLayout: 'TermsListDefaultLayout',
        // filterLayout: 'TermsFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getTerms',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
    },
    point: {
        listLayout: 'TermsListDefaultLayout',
        // filterLayout: 'TermsFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getTerms',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
    },
    fees: {
        listLayout: 'TermsListDefaultLayout',
        // filterLayout: 'TermsFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getTerms',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
    },
    detailTerms: {
        detailLayout: 'TermsDetailDefaultLayout',
        getFunc: 'getTerms',
        detailApiParamsSet: {
            c_idx: '',
            ty: '',
            id: '',
            // ty: 'service',
        },
        getSuccessType: 1,
        getErrorTypes: {},

        deleteFunc: 'deleteTerms',
        deleteApiParamsSet: {
            c_idx: '',
            c_type: '',
        },
        deleteSuccessType: 1,
        deleteFailTypes: {
        },
        deleteErrorTypes: {},
    },
    createTerms: {
        writeLayouts: ['TermsWriteDefaultLayout'],
        getFunc: 'getTerms',
        detailApiParamsSet: {
            ip: 0,
        },
        writeFunc: 'createTerms',
        writeApiParamSet: {},
        parsingData: {
            content: 'c_config',
            language: 'c_language'
        },
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {},
    },
    termsUpdate: {
        writeLayouts: ['TermsWriteDefaultLayout'],
        getFunc: 'getTerms',
        detailApiParamsSet: {
            ty: '',
            id: '',
        },
        parsingData: {
            content: 'c_config',
            language: 'c_language',
        },

        writeFunc: 'updateTerms',
        writeApiParamSet: {

        },
        writeSuccessType: 1,
        writeFailTypes: {},
        directUrl: '',
        directType: 'back',
    }
}
import util from "@/mixins/util";

export default {
    methods: {
        returnTermsConfig(type) {
            return configTerms[type];
        },

    },
    filterConfig: {
        cr: {
            type: 'between',
            classname: 'filterDate'
        },
        al: {
            type: 'between',
            classname: 'filterDate'
        },
        out: {
            type: 'between',
            classname: 'filterOutDate'
        },
        ni: {
            type: 'query',
            classname: 'searchInput',
        },
        mid: {
            type: 'query',
            classname: 'searchInput',
        },
        bid: {
            type: 'query',
            classname: 'filterStatus',
        },
        bl: {
            type: 'match',
            classname: 'filterStatus',
        },
        cmty:{
            type: 'terms',
            classname: 'filterType',
        },
        la: {
            type: 'terms',
            classname: 'langOption',
        },
        tab: {
            type: 'match',
            classname: 'tab'
        }

    }
}
